/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from 'styled-components';
import theme from './LoginPage.theme';

export const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10rem;
  width: 50rem;

  .cta {
    color: ${props => theme(props).linkColor};
    display: block;
    font-size: 0.875rem;
    margin-top: 0.75rem;
    text-decoration: underline;
  }
`;

export const LoginFormContainer = styled.div`
  width: 29rem;
`;

export const LoginTextContainer = styled.div`
  margin-left: 5.5rem;
  padding: 1rem 1rem;
  width: 14rem;
`;

export const FormTopWrapper = styled.div`
  margin-bottom: 0.75rem;
`;
export const LoginTextSubtitle = styled.span`
  display: block;
  font-weight: 600;
`;

export const LoginTextContent = styled.p`
  font-size: 0.875rem;
  /* stylelint-disable-next-line property-no-unknown */
  line-spacing: 1.5rem;
`;
